import { HStack, VStack, Text, Skeleton } from '@chakra-ui/react';
import React from 'react';

import { Bank } from '@finley-technologies/finley-types';

import { colors } from 'packages/common-frontend/colors';
import { formatCurrencyAmount } from 'packages/common-frontend/utils';
import { Icon } from '~/packages/common-frontend/components/icons';

export const SummaryCard = ({
  name,
  value,
  loading,
}: {
  name: string;
  value: number | string;
  loading?: boolean;
}) => {
  return (
    <HStack
      sx={{
        borderWidth: '1px',
        borderRadius: 'md',
        borderColor: colors.gray[100],
        p: '1.5rem',
        gap: '1rem',
        flex: 1,
      }}
    >
      <Icon icon="dollar" />
      <VStack align="flex-start">
        <Text color={colors.gray[600]} fontSize=".9rem" whiteSpace="nowrap">
          {name}
        </Text>
        {loading ? (
          <Skeleton h="3rem" w="100%" />
        ) : (
          <Text fontWeight={600} fontSize="1.5rem">
            {typeof value === 'number'
              ? formatCurrencyAmount(value, Bank.Currency.USD)
              : value}
          </Text>
        )}
      </VStack>
    </HStack>
  );
};
